/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Developer_ScopesInputs */



/**
* | output |
* | --- |
* | "Scopes" |
*
* @param {Developer_ScopesInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const developer_scopes = /** @type {((inputs?: Developer_ScopesInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Developer_ScopesInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Portées")
	if (locale === "es") return /** @type {LocalizedString} */ ("Alcances")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Escopos")
	if (locale === "it") return /** @type {LocalizedString} */ ("Scopes")
	return /** @type {LocalizedString} */ ("Scopes")
});